import React from "react";
import EditIcon from "../../../../assets/svgs/Edit.jsx";

const InsuranceDetails = () => {
  return (
    <div className="rounded-lg shadow-xl py-5 mb-10 text-sm sm:text-base">
      
      <div className="flex justify-between py-4 px-5 md:px-9 border-b text-base sm:text-lg">
        <p className="text-lg font-semibold">Insurance</p>
        <button className="space-x-1 w-9 h-9 p-1 text-white flex items-center justify-center rounded-full bg-gradient-to-tr from-pink-500 to-pink-600 shadow-lg">
          <EditIcon />
        </button>
      </div>

      <div className="px-9 py-6 space-y-4 md:space-y-0">
        <div className="w-full md:h-20 sm:w-2/4 md:w-2/6 lg:w-1/4 pr-3 inline-flex flex-col">
          <h3 className="font-medium">Name</h3>
          <p className="text-xs">Jane Cooper</p>
        </div>
        <div className="w-full md:h-20 sm:w-2/4 md:w-2/6 lg:w-1/4 pr-3 inline-flex flex-col">
          <h3 className="font-medium">Candidate_Id</h3>
          <p className="text-xs">10934JC</p>
        </div>
        <div className="w-full md:h-20 sm:w-2/4 md:w-2/6 lg:w-1/4 pr-3 inline-flex flex-col">
          <h3 className="font-medium">Sex</h3>
          <p className="text-xs">Female</p>
        </div>
        <div className="w-full md:h-20 sm:w-2/4 md:w-2/6 lg:w-1/4 pr-3 inline-flex flex-col">
          <h3 className="font-medium">Date of Birth</h3>
          <p className="text-xs">02-04-1992</p>
        </div>
        <div className="w-full md:h-20 sm:w-2/4 md:w-2/6 lg:w-1/4 pr-3 inline-flex flex-col">
          <h3 className="font-medium">Email</h3>
          <p className="text-xs">ckctm12@gmail.com</p>
        </div>
        <div className="w-full md:h-20 sm:w-2/4 md:w-2/6 lg:w-1/4 pr-3 inline-flex flex-col">
          <h3 className="font-medium">Address</h3>
          <p className="text-xs">
            P Janardhan Reddy Nagar, Gachibowli, Hyderabad, Telangana 500081
          </p>
        </div>
        <div className="w-full md:h-20 sm:w-2/4 md:w-2/6 lg:w-1/4 pr-3 inline-flex flex-col">
          <h3 className="font-medium">Citizenship</h3>
          <p className="text-xs">US</p>
        </div>
        <div className="w-full md:h-20 sm:w-2/4 md:w-2/6 lg:w-1/4 pr-3 inline-flex flex-col">
          <h3 className="font-medium">Phone Number</h3>
          <p className="text-xs">+919171722967</p>
        </div>
        <div className="w-full md:h-20 sm:w-2/4 md:w-2/6 lg:w-1/4 pr-3 inline-flex flex-col">
          <h3 className="font-medium">Security NUmber</h3>
          <p className="text-xs">465-42-1568</p>
        </div>
        <div className="w-full md:h-20 sm:w-2/4 md:w-2/6 lg:w-1/4 pr-3 inline-flex flex-col">
          <h3 className="font-medium">Occupation</h3>
          <p className="text-xs">Developer</p>
        </div>
        <div className="w-full md:h-20 sm:w-2/4 md:w-2/6 lg:w-1/4 pr-3 inline-flex flex-col">
          <h3 className="font-medium">BUsiness Address</h3>
          <p className="text-xs">
            4517 Washington Ave. Manchester, Kentucky 39495
          </p>
        </div>
        <div className="w-full md:h-20 sm:w-2/4 md:w-2/6 lg:w-1/4 pr-3 inline-flex flex-col">
          <h3 className="font-medium">Goverment Id Proof Number</h3>
          <p className="text-xs">3949567890543</p>
        </div>
      </div>
    </div>
  );
};

export default InsuranceDetails;
